/**
 * Sorts configs by their letter property.
 * First compares by length, then alphabetically if lengths are equal.
 */
export const sortConfigsByLetter = <T extends { letter?: string }>(configs: T[]): T[] => {
  return [...configs].sort((a, b) => {
    // First compare by length
    const lengthDiff = (a.letter?.length || 0) - (b.letter?.length || 0);
    if (lengthDiff !== 0) {
      return lengthDiff;
    }
    // If lengths are equal, compare alphabetically
    return (a.letter || '').localeCompare(b.letter || '');
  });
};
